import { APPLICATION_ROUTES } from 'constants/routes';
import { IconClipboardCheck, IconLayoutGrid, IconShoppingBag, IconTruck } from '@tabler/icons';
import { isPoaUiEnabled } from 'shared/utils/featureFlags';
import { NavItemType } from 'types';

const icons = {
    IconShoppingBag,
    IconLayoutGrid,
    IconClipboardCheck,
    IconTruck
};

// ==============================|| MENU ITEMS - ORDERING ||============================== //

const ordering: NavItemType = {
    id: 'ordering',
    title: 'Ordering',
    type: 'group',
    children: [
        {
            id: 'place-orders',
            title: 'Place Orders',
            type: 'item',
            url: APPLICATION_ROUTES.ordering.browse,
            icon: icons.IconShoppingBag,
            breadcrumbs: false
        },
        {
            id: 'order-dashboard',
            title: 'Order Dashboard',
            type: 'item',
            url: APPLICATION_ROUTES.ordering.status,
            icon: icons.IconLayoutGrid,
            breadcrumbs: false
        },
        {
            id: 'receipting',
            title: 'Receipting',
            type: 'item',
            url: APPLICATION_ROUTES.ordering.receiptingList,
            icon: icons.IconClipboardCheck,
            breadcrumbs: false
        },
        ...(isPoaUiEnabled()
            ? [
                  {
                      id: 'po-so-tracking',
                      title: 'PO & SO Tracking',
                      type: 'item' as const,
                      url: APPLICATION_ROUTES.poSoTracking,
                      icon: icons.IconTruck,
                      breadcrumbs: false
                  }
              ]
            : [])
    ]
};

export default ordering;
